import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { formatMoney, isNotNullOrEmpty } from "@utils/helpers/stringHelper";
import Wrapper, { LoanLimitProductType, Money, SelectLabelTypographyDiv } from "./loanLimit.styles";
import { useRequestedProductType } from "@hooks";

export const LoanLimit = () => {
  const [hideLoanLimit, setHideLoanLimit] = useState();
  let { loanReasonsResponse } = useSelector((state) => state.StartUp);
  loanReasonsResponse = loanReasonsResponse || [];
  const requestedProductType = useRequestedProductType();
  let currentProduct = loanReasonsResponse.find(item => item.type === requestedProductType);
  
  let availableLoanTypes = [];
  const requestedProductTypeLabel = currentProduct ? currentProduct.name : '';
  let min = 0;
  let max = 0;

  if (isNotNullOrEmpty(loanReasonsResponse)) {
    availableLoanTypes = loanReasonsResponse.map((data) => data.type);
  }

  if (isNotNullOrEmpty(loanReasonsResponse)) {
    loanReasonsResponse.forEach((property) => {
      if (property.type === requestedProductType) {
        min = property.from;
        max = property.to;
      }
    })
  }
  
  useEffect(() => {
    if (!requestedProductType || !availableLoanTypes.includes(requestedProductType)) {
      setHideLoanLimit(true);
    } else {
      setHideLoanLimit(false);
    }
  }, [requestedProductType, setHideLoanLimit, availableLoanTypes])

  if (hideLoanLimit) {
    return <></>;
  }

  return (
    <>
      {requestedProductType && (
        <Wrapper>
          <SelectLabelTypographyDiv>
            Loan Limit for <LoanLimitProductType>{requestedProductTypeLabel}</LoanLimitProductType>
          </SelectLabelTypographyDiv>
          <Money>{formatMoney(min)} - {formatMoney(max)}</Money>
        </Wrapper>
      )}
    </>
  );
} 
